import React, { useEffect, useRef, useState } from 'react';
import { getQuestion } from '../../service/theme';
import { themeStore, videoStore } from '../../store';
import styles from './assets/index.module.scss';
import './assets/index.css'
import Header from '../common/Header';
import useAnswer from '../../utils/useAnswer';
import useUrlSearch from '../../utils/useUrlSearch';
import { Toast } from 'antd-mobile';
import Loading from '../../utils/Loading';
import Emptyer from '../../utils/Emptyer';
import { useNavigate } from 'react-router-dom';

export default function DDS_lanhupage_0() {

  const { active } = videoStore;
  const [loadingquestion, setLoadingquestion] = useState(true);
  const [question, setQuestion] = useState([]); // 知识点下所有考题
  const [index, setIndex] = useState(0);        // 当前题目index
  const record = useRef([])                     // 记录当前题目是否已经答完
  const { isCompanyFinished } = themeStore
  const navigate = useNavigate()

  const { answerStatus, setanswerStatus, runExam, runCheckAnswer } = useAnswer(record);
  const { getByKey } = useUrlSearch();

  useEffect(() => {
    const knowledgeId = getByKey('exam');
    // console.log(knowledgeId)
    async function GetQuestions() {
      const res = await getQuestion({ knowledgeId: knowledgeId })
      // console.log(res)
      setLoadingquestion(false)
      if (res.status) {
        setQuestion(res.data)
      }
      else {
        Toast.show({
          content: res.msg
        })
      }
    }
    GetQuestions()
  }, [])

  const clickAnwser = (i) => {
    // console.log(record.current.length === 0)
    if (!record.current[index]) {
      const answer = ['A', 'B', 'C', 'D'][i];
      runExam({
        first: record.current.length === 0 ? true : false,
        knowledgeId: question[index].knowledgeId,
        testId: question[index].testId,
        answer,
      }, i, index)
      // record.current[index] = true
    }
  }

  return (
    <div className={`${styles.page} flex-col`}>
      <div className={`${styles.bd1} flex-col`}>
        {/* <Header className={`${styles.Header} flex-col`} >
          <div className={`${styles.mod1} flex-col`} />
        </Header> */}
        {
          loadingquestion ? <Loading /> :
            question.length > 0 ?
              <>
                <div className={`${styles.group1} flex-col`}>

                  <div className={`${styles.block1} flex-col`}>
                    <div className={`${styles.section1} flex-row justify-between`}>
                      <span className={`${styles.info1}`}>{active.videoTitle}</span>
                      <span className={`${styles.info2}`}>{index + 1}/{question.length}</span>
                    </div>
                    <span className={`${styles.paragraph1}`}>
                      {index + 1}.&nbsp;{question[index].test}
                    </span>
                    {
                      question[index].choose.match(/[\u4e00-\u9fa50-9\|\s|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u]+/g).map((item, i) => (
                        <div
                          key={question[index].testId + i}
                          className={`${styles.wrap2} flex-col answer`}
                        >
                          <span className={`${styles.info2}`}
                            onClick={() => clickAnwser(i)}>{['A', 'B', 'C', 'D'][i]}：{item.startsWith('、') ? item.substr(1) : item}</span>
                        </div>
                      ))
                    }
                    <button
                      className={`${styles.Button1} flex-col`}
                      onClick={() => {
                        // console.log(record.current, index, record.current[index])
                        if (answerStatus !== null) {
                          if (answerStatus === 'Y') {
                            // 考试完成
                            // Toast.show({
                            //   content: '该知识点考试已通过\n3秒后自动返回'
                            // })
                            if (isCompanyFinished) {
                              Toast.show({
                                content: '公司级课程已学完, 请选择部门'
                              })
                              navigate('/')
                            } else {
                              window.history.back()
                            }
                          } else {
                            //重新考试
                            setIndex(0)
                            record.current = []
                            setanswerStatus(null)
                          }
                          return
                        }
                        if (index < question.length) {
                          // record.current[index] 记录当前题目是否点击作答
                          if (record.current[index]) {
                            // 进入下一题
                            index < question.length - 1 && setIndex(index => index + 1)
                          } else {
                            Toast.show({
                              content: '请先选择答案'
                            })
                          }
                        }
                        if (record.current[question.length - 1] === true) {
                          // 全部答完
                          runCheckAnswer({ knowledgeId: question[0].knowledgeId })
                        }
                      }}
                    >
                      <span id='as' className={`${styles.txt3}`}>{index < question.length - 1 ? '下一题' : answerStatus !== null ? answerStatus === 'Y' ? '返回' : '重新考试' : '交卷'}</span>
                    </button>

                  </div>
                </div>
                {answerStatus === 'N' && <div style={{ color: 'red', margin: '4.83vw', fontSize: 18 }}>必须全部答对才考完</div>}
                {answerStatus === 'Y' && <div style={{ color: '#009c02', margin: '4.83vw', fontSize: 18 }}>🎉 恭喜, 全部答对</div>}
              </> : <Emptyer />
        }
      </div>
    </div>
  )
}
